export default __webpack_public_path__ + "files/Phase1_Files.zip";